// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.j8Z5cWOvyBcMA6uNyvq9{flex-direction:column;align-items:center;margin-top:-36px;display:flex}.TU6OhW_0Uzov5I6ElUMq{border:1px solid var(--border-neutral-default);border-radius:8px;align-items:center;gap:14px;padding:7px 7px 6px 11px;display:flex}.HPV13h6WbeUF4SS_D3yg{flex:1}.sK6Skx0xKseBwfS7kUIM{cursor:pointer}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `j8Z5cWOvyBcMA6uNyvq9`,
	"urlWrap": `TU6OhW_0Uzov5I6ElUMq`,
	"url": `HPV13h6WbeUF4SS_D3yg`,
	"link": `sK6Skx0xKseBwfS7kUIM`
};
export default ___CSS_LOADER_EXPORT___;
